import React, { memo, useEffect, useState } from "react";
import CusButton from "../../mui/custom_button/CusButton";
import GameItemSupportBonus from "../../mui/game_tem/GameItemSupportBonus";
import useColor from "../../../hooks/other/useColor";
import { API_CASINO } from "../../../api/casino";
import { TEST_MODE } from "../../../store/enums";
import { useAppSelector } from "../../../store/index.ts";

const ProviderItemGames = memo(
  ({ provider, setLockPage }) => {
    const collectionId = useAppSelector((state) => state.common.collectionId);
    const { headerStyle } = useColor();

    const providerName = provider.name;
    const providerId = provider.id;

    const [games, setGames] = useState([]);

    useEffect(() => {
      if (TEST_MODE) {
        setLockPage(false);
        return;
      }
      API_CASINO.list
        .providerGames({ providerId: +providerId, collectionId: +collectionId, maxGames: 30 })
        .then((e) => {
          const list = e.data.list;
          setGames(list);
          setLockPage(false);
        })
        .catch(console.error);
    }, [providerId, collectionId]);

    return (
      <div className="games__providers__item" key={provider.name}>
        <div className="games__providers__item__header">
          <h2 style={headerStyle}>{provider.name}</h2>
          <CusButton color="custom" text="Show all" to={`/games/provider/${providerName}`} />
        </div>

        <div className="games__games">
          {games?.map((el, indx) => (
            <GameItemSupportBonus
              currentGame={el}
              key={el.game_id || indx}
              name={el.name}
              image={el.image}
            />
          ))}
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.provider.id === nextProps.provider.id;
  }
);
ProviderItemGames.displayName = "ProviderItemGames";

export default ProviderItemGames;
